<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>Shopify</h3>
      </div>
      <div class="box-content">
        <p>
          Para começar a útilizar precisamos que você informe o link da sua loja
          da shopify e a apikey gerada para acesso.
        </p>
        <p class="margin-top-s">Permissões de leitura necessárias no app da único tracker dentro da shopify: <b>Produtos, Pedidos, Inventários</b></p>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Link da loja shopify</label>
              <input class="input" type="text" v-model="storeLink" />
            </div>
            <div class="item flex-1">
              <label>ApiKey</label>
              <input class="input" type="text" v-model="storeApiKey" />
            </div>
          </div>
          <div class="flex margin-top-l row">
            <div class="flex-1">
              <div class="flex">
                <label
                  >Taxa de Checkout + Gateway (Adicionar o valor em
                  percentual)</label
                >
              </div>
              <div class="flex-1">
                <input
                  class="input"
                  style="width: 90px; min-width:90px"
                  :max="100"
                  :min="0"
                  type="number"
                  v-model="taxGatewayCheckout"
                />
                %
              </div>
            </div>
            <div class="flex-1 column">
              <div class="flex column">
                <div class="flex">
                  <label>Não utilizar valor do frete como lucro</label>
                </div>
                <div class="flex-1">
                    <m-switch
                      v-model="shipping_have_cost"
                    ></m-switch>
                </div>
              </div>
              <div class="flex column margin-top-l">
                <div class="flex">
                  <label>Atualizar custo dos produtos pelos valores cadastrados na SHOPIFY</label>
                </div>
                <div class="flex-1">
                    <m-switch
                      v-model="update_cost_from_shopify"
                    ></m-switch>
                </div>
              </div>
            </div>
          </div>
          <div class="flex margin-top-s">
            <div class="">
              <div class="button primary" @click="saveShopify()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
  deleteIntegration,
} from "@/services/integration";

import MSwitch from "@/components/MSwitch.vue";

export default {
  name: "shopify",
  components: {
    MSwitch
  },
  data() {
    return {
      storeLink: "",
      storeApiKey: "",
      taxGatewayCheckout: 6.5,
      shipping_have_cost: false,
      update_cost_from_shopify: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    saveShopify() {
      let data = {
        storeLink: this.storeLink,
        storeApiKey: this.storeApiKey,
      };

      if (!data.storeLink || !data.storeApiKey) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        shopify: {
          store_url: this.storeLink,
          api_key: this.storeApiKey,
          tax_gateway_checkout: this.taxGatewayCheckout,
          shipping_have_cost: this.shipping_have_cost,
          update_cost_from_shopify: this.update_cost_from_shopify,
        },
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          console.log("result", result);
          this.storeLink = result.shopify.store_url;
          this.storeApiKey = result.shopify.api_key;
          this.taxGatewayCheckout = result.shopify.tax_gateway_checkout;
          this.shipping_have_cost = result.shopify.shipping_have_cost;
          this.update_cost_from_shopify = result.shopify.update_cost_from_shopify;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },
    deleteIntegration() {
      deleteIntegration()
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
